import { CommonModule } from '@angular/common';
import { Component, inject, computed, Output, EventEmitter, OnInit } from '@angular/core';
import { MeetingsItemCardComponent } from '../meetings-item-card/meetings-item-card.component';
import { MeetingService } from '@/app/plateformebeneficiaire/core/service/meeting.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-meetings-sidebar',
  imports: [
    CommonModule,
    MeetingsItemCardComponent,
    ProgressSpinnerModule
  ],
  templateUrl: './meetings-sidebar.component.html',
  styleUrl: './meetings-sidebar.component.scss',
  standalone: true
})
export class MeetingsSidebarComponent implements OnInit {
  @Output() updateMeetingEvent = new EventEmitter<void>();

  startOfToday = new Date();

  ngOnInit() {
    this.startOfToday.setHours(0, 0, 0, 0);
  }

  #meetingService = inject(MeetingService);
  #meetingsQuery = this.#meetingService.getMeetings(1, 15);
  meetings = computed(() => this.#meetingsQuery.data()?.items ?? []);

  meetingsIncomming = computed(() => this.meetings().filter((x: any) => new Date(x.dateTimeDebut).getTime() >= this.startOfToday.getTime()) ?? []);
  meetingsPast = computed(() => this.meetings().filter((x: any) => new Date(x.dateTimeDebut).getTime() < this.startOfToday.getTime()) ?? []);

  isLoading = computed(() => this.#meetingsQuery.isLoading());

  updateMeeting(meeting: any) {
    this.updateMeetingEvent.emit(meeting);
  }
}